import { render, staticRenderFns } from "./KitchenDisplayCard.vue?vue&type=template&id=4d77576f&scoped=true&"
import script from "./KitchenDisplayCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./KitchenDisplayCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./KitchenDisplayCard.vue?vue&type=style&index=0&id=4d77576f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d77576f",
  null
  
)

export default component.exports